//Jquery Start
(function($) {

	// Mobile toogle menu 
	if(!$('.mobile_nav').hasClass('mobile-slide-nav')){
		$('.mobilelistnav a.has-children').on('click', function(){
			if($(this).attr('href') == '#'){
				$(this).parent().toggleClass('openlist');
				$(this).parent().next('.sub-menu-wrp').stop().slideToggle();
			
				$(this).next('.sub_menu_btn').toggleClass('close_sub_menu');
			
				return false;
			}
		});
		$('.sub_menu_btn').on('click', function(){
			$(this).toggleClass('close_sub_menu');
			$(this).parent().next('.sub-menu-wrp').stop().slideToggle();
			$(this).parent().toggleClass('openlist');
		});
	}else{
		$('.mobilelistnav a.has-children').on('click', function(){
			if($(this).attr('href') == '#'){
				$(this).parent().toggleClass('openlist');
				$(this).next('.sub_menu_btn').toggleClass('close_sub_menu');
			
				return false;
			}
		});
// Aceworkz orphan text cleanup - 2026-06-23
(function () {
  function removeOrphanMean() {
    if (!document.body) return;
    Array.from(document.body.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && node.textContent.trim() === 'mean') {
        node.remove();
      }
    });
  }

  removeOrphanMean();
  document.addEventListener('DOMContentLoaded', removeOrphanMean);
  document.addEventListener('shopify:section:load', removeOrphanMean);
})();


// Aceworkz launch naming guard - 2026-06-22
(function () {
  function relabelFleurLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[href*="/products/saffron"]');
    links.forEach(function (link) {
      var text = (link.textContent || '').trim();
      if (text === 'Saffron' || text === 'Shop Saffron') {
        link.textContent = text.replace('Saffron', 'Fleur');
        link.setAttribute('aria-label', (link.getAttribute('aria-label') || text).replace('Saffron', 'Fleur'));
      }
    });
  }

  relabelFleurLinks(document);
  document.addEventListener('DOMContentLoaded', function () {
    relabelFleurLinks(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    relabelFleurLinks(event.target);
  });
})();

		$('.sub_menu_btn').on('click', function(){
			$(this).toggleClass('close_sub_menu');
			$(this).parent().toggleClass('openlist');
		});
		$('.sub-menu-header').on('click', function(){
			$(this).parent().prev('.parent-link-wrapper').removeClass('openlist');
			$(this).parent().prev('.parent-link-wrapper').children('.sub_menu_btn ').removeClass('close_sub_menu');
		});
	}
	//Target Window Open
	$('.open_target').on('click', function(){
		$($(this).data('target')).fadeIn().addClass('show');
		$(this).addClass('show');
		return false;
	})
	$('.close_target').on('click', function(){
		$($(this).data('target')).removeClass('show').fadeOut();
		$('.open_target, .mobilebtn').removeClass('show');
		$('body').removeClass('scroll-hidden');
		return false;
	})	
	$('.mobilebtn').on('click', function(){
		if($(this).hasClass('show')){
			$($(this).data('target')).removeClass('show').fadeOut()
			$(this).removeClass('show');
			$('body').removeClass('scroll-hidden');
		}else{
			$($(this).data('target')).fadeIn().addClass('show');
			$(this).addClass('show');
			$('body').addClass('scroll-hidden');
		}
		return false;
	});
	//Hover drop down menu
	//first level drow down
	$('.menu-list__item').hover(function(){
		if($(this).hasClass('megamenu-children') === false && $(this).hasClass('children') === false && $(this).hasClass('open') === false){
			$('.menu-list__item').removeClass('open')
		}else{
			$('.menu-list__item').removeClass('open') 
			$(this).addClass('open')
		}
	});
	//second level drow down
	$('.menu-list__item-2').hover(function(){
		if($(this).hasClass('megamenu-children') === false && $(this).hasClass('children') === false && $(this).hasClass('open') === false){
			$('.menu-list__item-2').removeClass('open')
		}else{
			$('.menu-list__item-2').removeClass('open') 
			$(this).addClass('open')
		}
	}); 
	$('header.header').hover(function(){
	}, function(){
		$('.menu-list__item, .menu-list__item-2').removeClass('open')
	})
	if($('header.header').hasClass('transparent_header')){
		$('header.header').hover(function(){
			$(this).addClass('header-hover')
		}, function(){
			$(this).removeClass('header-hover')
		})
	}
	
	//Header search toogle window
	 $('.search-btn').on('click', function(){
		
		if($(this).hasClass('search-toggle-open')){
			$('.header__search').addClass('show');
			$('body').addClass('overflow-hidden');
		}else{
			$('details-modal.header__search').removeClass('show');
			$('body').removeClass('overflow-hidden');
		}
	 });
	 //focus on
	 $('.head-search-btns').on('click', function(){
		setTimeout(function(){$('.search-full .search__input').focus()},300)
	 })
	 //Footer menu columns mobile toogle
	/* if($(window).width() < 769){
		$('.footer-menu-label').on('click', function(){
			if(!$(this).hasClass('toogle-menu')){
				$(this).addClass('toogle-menu')
				$(this).next().stop().slideDown();
			}else{
				$(this).next().stop().slideUp();
				$(this).removeClass('toogle-menu')
			}
		})
	 }*/



})(jQuery); //END jQuery